export const AppTypeRef: { [id: string]: string; } = {
    "12": "UG Ballot Final Year",
    "13": "UG 2nd Year Returner Overseas Fees",
    "14": "UG 3rd/4th Year Returner Overseas Fees",
    "23": "UG Waiting List",
    "24": "PG Waiting List",
    "48": "PG Southend Returner",
    "49": "UG Southend Returner",
    "56": "Returning Essex Abroad",
    "68": "UG Waiting List Southend",
    "69": "PG Waiting List Southend",
    "72": "UG Ballot 2nd/3rd Year",
    "114": "Returning Essex Abroad Southend"
};